import { useGetCreditBalanceSummaryOption } from '@/service/payment/hook';
import { fCurrencyUSDExtended } from '@/utils/formatNumber';
import { Coins } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

const ViewCreditMini = () => {
  const { data, isLoading } = useQuery({
    ...useGetCreditBalanceSummaryOption(),
  });
  const totalAvailableCredit = data?.balances?.[0]?.available_balance?.monetary?.value
    ? Number(data.balances[0].available_balance.monetary.value) / 100
    : 0;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to={PATH_PAGE.setting.payment}
            className="flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-sm hover:bg-muted transition-colors"
          >
            <Coins className="h-4 w-4 text-muted-foreground" />
            {isLoading ? (
              <Skeleton className="h-4 w-12" />
            ) : (
              <span className={totalAvailableCredit <= 0 ? 'text-destructive font-medium' : 'font-medium'}>
                {fCurrencyUSDExtended(totalAvailableCredit)}
              </span>
            )}
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>Credit Balance</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ViewCreditMini;
